var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prod-image"},[_c('img',{staticClass:"full-width",attrs:{"src":_vm.image.url,"alt":_vm.image.alt_text}})])}
var staticRenderFns = []

export { render, staticRenderFns }